import { render } from "./NumberInput.vue?vue&type=template&id=6d49a880&scoped=true"
import script from "./NumberInput.vue?vue&type=script&lang=js"
export * from "./NumberInput.vue?vue&type=script&lang=js"

import "./NumberInput.vue?vue&type=style&index=0&id=6d49a880&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d49a880"]])

export default __exports__